








































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'
import RawInput from '@/modules/shared/components/shared/kit/RawInput'

@Component({
  components: { RawInput },
  inheritAttrs: false
})
export default class BaseInput extends Vue {
  @ModelSync('value', 'input') valueSync: string | number

  @Prop({ default: 'tes-navy-blue-darker' }) color!: string
  @Prop({ default: '' }) readonly label!: string
  @Prop({ default: 'text-tes-navy-blue-darker' }) readonly labelColor!: string
  @Prop({ default: 'text' }) readonly type!: string
  @Prop({ default: false }) readonly disable!: boolean
  @Prop({ default: false }) flatLeft: boolean
  @Prop({ default: false }) hasEmoji: boolean

  get __value() {
    return this.valueSync
  }

  set __value(value) {
    this.valueSync = value
  }

  get __attrs() {
    return this.$attrs
  }

  get __listeners() {
    return this.$listeners
  }
}
